import React, { Component } from "react";
import { withRouter, NavLink } from "react-router-dom";
import {
  BoxDanger,
  MnemoCallout,
  MnemoLoading,
  MSection,
  SupportoTecnicoLive,
  Title,
} from "components/misc";
import { CourseHelper, dateHelper, lessonLiveService, learningService, networkErrorHelper, stringHelper } from "libs";
import { ROUTES } from "const";
import { Icon, Button } from "design-react-kit";

class CourseLessonLiveScheduleOnline extends Component {

  state = {
    loading: true,
    loadingError: false,
    rCode: "",
    course: {},
    userCourse: {},
    lessonsStage1: [],
    liveClassesStage1: null,
    lessonsStage2: [],
    liveClassesStage2: null,
    lessonsStage3: [],
    liveClassesStage3: null,
     analyticsData: null,
  };

  componentDidMount() {
    const { rCode } = this.props.match.params;
    this.setState({ rCode: rCode });

    this.loadUserCourse(rCode);
  }

  loadUserCourse(rCode) {

    learningService
      .courseDashboard(rCode)
      .then(({ data }) => {

        const { course, userCourse } = data.payload;
        this.setState({ course, userCourse });

        this.loadRemoteStage1(course.id, rCode);
        
        this.loadRemoteStage2(course.id, rCode);
        this.loadRemoteStage3(course.id, rCode);

        this.loadAnalyticsData(rCode);
      })
      .catch(error => {

        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        }
      });
  }

  loadAnalyticsData(rCode) {
    learningService
      .courseAnalyticsData(rCode)
      .then(({ data }) => {
        this.setState({
          analyticsData: data.payload.analytic,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  loadRemoteStage1(courseId, rCode) {
    lessonLiveService
      .MyScheduleStageOnline(courseId, 1, rCode)
      .then(({ data }) => {
        this.setState({
          loading: false,
          lessonsStage1: data.payload.lessonLiveSchedules,
          liveClassesStage1: data.payload.lessonLiveClass,
        });
      })
      .catch((error) => {
        console.log(error)
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        }

        this.setState({
          loading: false,
          ladingError: true,
        });
      });
  }

  loadRemoteStage2(courseId, rCode) {

    lessonLiveService
      .MyScheduleStageOnline(courseId, 2, rCode)
      .then(({ data }) => {
        this.setState({
          loading: false,
          lessonsStage2: data.payload.lessonLiveSchedules,
          liveClassesStage2: data.payload.lessonLiveClass,
        });
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        }

        this.setState({
          loading: false,
          ladingError: true,
        });
      });
  }

  loadRemoteStage3(courseId, rCode) {
    lessonLiveService
      .MyScheduleStageOnline(courseId, 3, rCode)
      .then(({ data }) => {
        this.setState({
          loading: false,
          lessonsStage3: data.payload.lessonLiveSchedules,
          liveClassesStage3: data.payload.lessonLiveClass,
        });
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        }

        this.setState({
          loading: false,
          ladingError: true,
        });
      });
  }

  showLinkIdMeet(lesson) {

    let show = false;

    if (lesson.idMeet) {

      const dayLeft = dateHelper.dayLeft(dateHelper.toUSDate(lesson.date));
      if (dayLeft === 0) {
        const minuteLeft = dateHelper.minuteLeft(lesson.hourStart);

        // il link si attiva da 60 minuti prima a 4 ore dopo l'inizio della lezione
        if (minuteLeft < 60 && minuteLeft > -240) {
          show = true;
        }
      }
    }

    return show;
  }

  showLinkUrlRegister(lesson) {

    let show = false;

    if (lesson.urlRegister) {

      const dayLeft = dateHelper.dayLeft(dateHelper.toUSDate(lesson.date));
      if (dayLeft === 0) {
        const minuteLeft = dateHelper.minuteLeft(lesson.hourStart);

        // il link si attiva da 2 ore  prima a 4 ore dopo l'inizio della lezione
        if (minuteLeft < 180 && minuteLeft > -240) {
          show = true;
        }
      }
    }

    return show;
  }

  goDetail = (idLessonLive) => {
    const { rCode } = this.state;
    window.location = `${ROUTES.COURSE_LESSONLIVE_DETAIL}/${rCode}/${idLessonLive}`;
  };

  openLink = (link) => {
    window.open(link, '_blank');
  };

  renderStage(lessonsStage) {

    /* PINA teams 25.11.2025: non ci sarà una seconda 
    if (stage !== 3) {
      label = (stage === 1) ? "Prima fase del percorso" : "Seconda fase del percorso";
    }*/

    const isTchaikovsky = CourseHelper.isTchaikovsky(this.state.course.code);

    return (<MSection className="m-2">
      {lessonsStage.length > 0 ? (

        <>
          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col">Data</th>
                <th scope="col" className="minw-85">{(isTchaikovsky) ? 'CFA' : 'CFU'}</th>
                <th scope="col"> {(isTchaikovsky) ? 'SAD' : 'SSD'}</th>
                <th scope="col">Insegnamento</th>
                <th scope="col">Ora Inizio</th>
                <th scope="col">Docente</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {lessonsStage.map((lesson, i) => (
                <tr key={i}>
                  <td>{dateHelper.toITDate(lesson.date)}</td>
                  <td className="minw-85">{lesson.cfu}</td>
                  <td>{(isTchaikovsky && lesson.sad) ? lesson.sad : lesson.ssd}</td>
                  <td>{lesson.subject}</td>
                  <td>{dateHelper.toShortTime(lesson.hourStart)}</td>
                  <td>{lesson.teacher}</td>
                  <td>
                    {this.showLinkUrlRegister(lesson) && (
                      <Button
                        color="primary m-1"
                        outline
                        onClick={(e) => {
                          this.openLink(lesson.urlRegister);
                        }}>
                        Registrati
                      </Button>
                    )}
                    {this.showLinkIdMeet(lesson) && (
                      <>
                        <Button
                          color="primary m-1 btn-block"
                          outline
                          onClick={(e) => {
                            this.openLink(lesson.idMeet);
                          }}>
                          Partecipa
                          {(parseInt(lesson.myRegistrationIDWebex) > 0) && <div><small className="text-muted">codice registrazione: {lesson.myRegistrationIDWebex}</small></div>}
                        </Button>

                      </>
                    )}

                    <Button
                      id="radio"
                      color="primary bg-dark m-1 btn-block"
                      onClick={(e) => {
                        this.goDetail(lesson.id);
                      }}>
                      Dettaglio
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      ) : (
        <p>
          Il Calendario delle lezioni sarà disponibile prossimamente.
        </p>
      )}
    </MSection>)
  }

  render() {
    const {
      loading,
      loadingError,
      lessonsStage1,
      lessonsStage2,
      lessonsStage3,
      rCode,
      userCourse,
      analyticsData,
    } = this.state;

    if (loading) return <MnemoLoading></MnemoLoading>;
    if (loadingError)
      return (
        <BoxDanger className="m-5">
          Si è verificato un errore durante l'elaborazione della richiesta.  <SupportoTecnicoLive courseCode={userCourse.courseCode} />
        </BoxDanger>
      );

    const isCFUAll = CourseHelper.isCFUAll(userCourse.courseCode) ? true : false;
    //const subTitle1 = (liveClassesStage1 && liveClassesStage1.length > 0) ? liveClassesStage1[0].label : "";
    //const subTitle2 = (liveClassesStage2 && liveClassesStage2.length > 0) ? liveClassesStage2[0].label : "";
    //const subtitle3 = "9 Giugno 2025: lezioni propedeutiche allo svolgimento delle prove finali";

    let percent = "0%";
    let lastUpdate = null;

    if (analyticsData) {      
      let studentPercent = (analyticsData.minutes * 1.0) / analyticsData.totalMinutes;
      console.log("studentPercent", studentPercent,analyticsData);
      if (studentPercent > 1) studentPercent = 1;
      percent = stringHelper.formatPercentage(studentPercent);

      if (analyticsData.lastUpdate) {
        lastUpdate = ` (ultimo aggiornamento ${dateHelper.toITDateTime(analyticsData.lastUpdate)})`;
      }
    }
    return (
      <>
        <NavLink
          to={`${ROUTES.COURSE_DASHBOARD}/${rCode}`}
          className="mx-5 btn btn-outline-primary float-right">
          <Icon icon="it-presentation" /> TORNA ALLA HOME PAGE DEL CORSO
        </NavLink>
        {(isCFUAll) ? (
          <Title>Attività telematiche in modalità sincrona</Title>
        ) : (
          <Title>Attività formativa</Title>
        )}

        {(lessonsStage3 && lessonsStage3.length > 0) && this.renderStage(lessonsStage3)}

        <MnemoCallout className="mnemo-callout-success m-2">
          <h5>
            Percentuale di frequenza calcolata con riferimento all'intera durata del corso: {percent}
            {lastUpdate && <small>{lastUpdate}</small>}
          </h5>
        </MnemoCallout>

        {/** stage1 grid view */}
        {this.renderStage(lessonsStage1)}

        {/** stage2 grid view */}
        {(lessonsStage2 && lessonsStage2.length > 0) && this.renderStage(lessonsStage2)}

        <MnemoCallout className="mnemo-callout-success m-2">
          <p>L'accesso alla singola lezione, erogata in modalità sincrona, sarà consentito entro 60 minuti dall'orario
            di inizio indicato nel Calendario, secondo modalità che verranno comunicate tempestivamente. Decorso
            tale intervallo non sarà più possibile accedere o rientrare nella lezione.</p>
        </MnemoCallout>
        <SupportoTecnicoLive courseCode={userCourse.courseCode} />.
      </>
    );
  }
}

export default withRouter(CourseLessonLiveScheduleOnline);
